import { QueryClientScope } from "../types";
import { setUserSetting } from "./setUserSetting";
import { UserSettingsKey, SetUserSettingsResponse } from "./types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useSetUserSetting = () => {
  const queryClient = useQueryClient();

  return useMutation<SetUserSettingsResponse, Error, { key: UserSettingsKey; value: string | boolean }>({
    mutationFn: ({ key, value }) => setUserSetting(key, value),
    onSuccess: (data) => {
      queryClient.setQueryData([QueryClientScope.UserSetting, data.key], data);
    },
    retry: false,
  });
};
